import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import React, { Component } from 'react';

import './styles.css';

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        <Collapse in={this.state.openNotificationModal === true}>
          <Alert
            severity={
              this.state.is_authenticated === true ? 'success' : 'error'
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.setState({ openNotificationModal: false });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle>
              {this.state.is_authenticated === true
                ? this.state.modalTitle
                : this.state.modalTitleFailure}
            </AlertTitle>
            {this.state.is_authenticated === true
              ? this.state.modalDetail
              : this.state.modalDetailFailure}
          </Alert>
        </Collapse>
      </>
    );
  }
  render() {
    return (
      <>
        <div id="privacy-policy-container" className="toc">
          <div className="title">
            <h1>SecurityProgram360.com Website Privacy Policy</h1>
            <p style={{ marginTop: -25 + 'px', marginBottom: 25 + 'px' }}>
              Last updated: April 17, 2024
            </p>
          </div>
          <div id="intro">
            <h2>Introduction</h2>
            <p>
              SecurePoint 360 is committed to protecting the privacy of our
              customers. Our mission is to address all the security needs of
              SMBs while maintaining our dedication to high quality, timely, and
              cost-effective solutions. Our comprehensive services range from
              preparation for security audits your clients require to protecting
              your attack surface before the inevitable happens.
            </p>
            <p>
              Our Privacy Policy is designed to help you understand how we
              collect and use personally identifiable information (“Personal
              Information”) that you provide us and to help you make informed
              decisions when using our website and services (collectively,
              “SecurePoint 360”, Company, or “Website”).
            </p>
            <p>
              By visiting or using any part of this website, you agree to the
              terms of this Privacy Policy as they may be amended from time to
              time. As we update our website over time, this Privacy Policy may
              change, so please check for updates.
            </p>
            <p>
              Read the{' '}
              <a href="#USRegional">
                <span className="hyperlink">
                  United States Regional Privacy Notice
                </span>
              </a>{' '}
              for more details about how we handle Personal Information and how
              to exercise your rights.
            </p>
          </div>
          <div id="online-privacy-responsibilities">
            <h2>Your Online Privacy Responsibilities</h2>
            <p>
              By using this site, you agree to take basic steps to ensure your
              privacy online. You agree to log out of this site when you are
              finished, protecting your information from other users. You also
              agree not to share your password or login ID with anyone else. In
              addition, you agree to take reasonable precautions against malware
              and viruses by installing anti-virus software to protect your
              online activities.
            </p>
          </div>
          <div id="personal-information">
            <h2>What Is Personal Information?</h2>
            <p>
              <strong>"Personal Information"</strong> means any information
              relating to an identified or identifiable natural person; an
              identifiable natural person is one who can be identified, directly
              or indirectly, in particular by reference to an identifier such as
              a name, an identification number, location data, an online
              identifier or to one or more factors specific to the physical,
              physiological, genetic, mental, economic, cultural or social
              identity of that natural person.
            </p>
            <p>
              Personal Information may include the following: name, address,
              date of birth, gender, and contact data (i.e., email address,
              telephone number, and employer name).
            </p>
            <p>
              We may also collect information that is related to you but that
              does not personally identify you{' '}
              <strong>("Non-personal Information").</strong> Non-personal
              Information also includes information that could personally
              identify you in its original form, but that we have modified (for
              instance, by aggregating, anonymizing, or de-identifying such
              information) in order to remove or hide any Personal Information.
            </p>
          </div>
          <div id="scope">
            <h2>Scope of This Privacy Policy</h2>
            <p>
              This Privacy Policy applies to Personal Information and other
              information collected by SecurePoint 360 or its service providers
              from or about:
            </p>
            <ul>
              <li>Visitors to, or users of, its websites</li>
              <li>
                Prospective and current customers using SecurePoint 360 services
              </li>
              <li>Service providers and business partners</li>
              <li>Prospective and current employees</li>
              <li>Other third-parties that it interacts with</li>
            </ul>
            <p>
              We collect this information to continually improve and enhance the
              functionality of SecurePoint 360. We gather certain information
              automatically. This information may include IP addresses, browser
              type, Internet service provider (ISP), referring/exit pages,
              operating system, date/time stamp, and/or clickstream data. We
              link this automatically collected data to other information we
              collect about you.
            </p>
          </div>
          <div id="collection-of-personal-information">
            <h2>Collection of Personal Information</h2>
            <p>
              We take your privacy seriously and employ information protection
              controls in keeping with industry standards and practices to
              safeguard your information and protect your anonymity. Personal
              Information about you may be collected from you through various
              sources, including information i) that is entered manually and
              voluntarily by you on the Site’s application and other forms or
              postings on the Site; ii) that you provide regarding your
              preferences (for example, based on your activity on our website);
              iii) from other sources with your consent (for example, from other
              institutions such as auditors or administrators); iv) from sources
              in the public domain; and v) from other interactions you may have
              with us (for example, discussions or emails with our staff,
              including through the use of the Site’s contact features).
            </p>
            <p>
              In addition, when you visit our Site, we may gather anonymous
              technical and navigational information, such as computer browser
              type, Internet protocol address, cookie information, pages
              visited, and average time spent on our website. This information
              does not personally identify you and may be used, for example, to
              alert you to software compatibility issues, to customize any
              advertising or content you see, fulfill your requests for products
              and services, contact you, conduct research, or analyze and
              improve our Site design and functionality.
            </p>
            <p>
              Such information collected by us may be stored and processed in
              the United States or any other country in which our agents or we
              maintain facilities. By using the Service, you consent to the
              foregoing collection and use of information and any such transfer
              of information outside of your country. We make no representation
              or warranty with respect to any duty to permanently store any
              Personal Information you may provide.
            </p>
          </div>
          <div id="personal-information-you-choose-to-provide">
            <h2>Personal Information you choose to provide</h2>
            <p>
              In order to provide the best experience when you visit our
              website, we may ask you for Personal Information. Personal
              Information includes, for example, your name and e-mail address,
              both of which you may be asked to provide when registering with
              SecurePoint 360. A description of some of the ways that you may
              provide Personal Information to us, as well as further details on
              how we may use such Personal Information, is given below.
            </p>
            <h3>Contact us/feedback</h3>
            <p>
              If you email us using a “CONTACT US” link on our website, we may
              ask you for information such as your name and e-mail address so we
              can respond to your questions and comments. If you choose to
              correspond with us via e-mail, we may retain the content of your
              e-mail messages, your e-mail address, and our response to you.
            </p>
            <h3>Surveys</h3>
            <p>
              We may occasionally ask website visitors to complete online
              surveys and opinion polls about their activities, attitudes, and
              interests. These surveys help us improve our products and
              services. When asking for participation in these surveys, we may
              ask you to provide us with your name and email address.
            </p>
            <h3>Website Forms</h3>
            <p>
              Our website may offer visitors contact forms to request additional
              details and to download collateral. If you fill out one of our web
              forms, we may ask you for information such as your name and email
              address so we can respond to your questions and comments. If you
              choose to correspond with us via web forms, we may retain the form
              data which can include name, email address, and other contact
              related details.
            </p>
            <h3>Support Community Q&amp;A Posts</h3>
            <p>
              Our website offers individuals the opportunity to ask questions
              and answer questions in our SecurePoint 360 Community site that
              may contain self-reported demographics. If you choose to
              correspond with us and the community, we may retain the data which
              could include name, email address, and other contact related
              details.
            </p>
          </div>
          <div id="website-usage-information">
            <h2>Website usage information</h2>
            <h3>Cookies</h3>
            <p>
              When visiting SecurePoint 360, we may use cookies on or in
              connection with our website to maintain information about you. A
              cookie is a very small text document, which often includes an
              anonymous unique identifier and additional information necessary
              to support the site’s intended functionality. SecurePoint 360 uses
              session cookies. A session cookie is temporary and disappears
              after you close your browser.
            </p>
            <p>
              Technologies such as cookies, beacons, tags, and scripts are used
              by SecurePoint 360 and our marketing partners, analytics
              providers, and customer support systems. These technologies are
              used in analyzing trends, administering the site, tracking user’s
              movements around the site, and to gather demographic information
              about our user base as a whole. We may receive reports based on
              the use of these technologies by these companies on an individual
              as well as aggregated basis.
            </p>
            <p>
              We use cookies for marketing and for authentication. Users can
              control the use of cookies at the individual browser level. If you
              reject cookies, you may still use our site, but your ability to
              use some features or areas of our site may be limited.
            </p>
            <p>
              To learn more and for a detailed cookie notice, the User may
              consult the{' '}
              <a href="https://securepoint360.com/opt-out-preferences/">
                Cookie Policy
              </a>
              .
            </p>
            <p>
              Most web browsers can be set to tell you when a cookie has been
              sent to you and give you the opportunity to refuse that cookie.
            </p>
            <p>
              Refusing a cookie may in some cases prevent you from using or
              negatively impact the display or function of our website or
              certain areas or features of our Website. There are numerous
              resources on the Internet that can provide more information about
              how cookies work and how you can manage them.
            </p>
            <h3>Web beacons</h3>
            <p>
              Web Beacons, also known as pixel tags and clear GIFs, (“Web
              Beacons”), are electronic images that allow a website to access
              cookies and help track marketing campaigns and general usage
              patterns of visitors to those websites. Web Beacons can recognize
              certain types of information, such as cookie numbers, time, and
              date of a page view, and a description of the page where the Web
              Beacons is placed. No personally identifiable information about
              you is shared with third parties through the use of Web Beacons on
              the Site. However, through Web Beacons, we may collect general
              information that will not personally identify you, such as
              Internet browser, operating system, IP address, date of visit,
              time of visit, and path taken through the Site.
            </p>
            <p>
              Internal use of Web Beacons: SecurePoint 360 may use Web Beacons
              internally to count visitors and recognize visitors through
              cookies. Access to cookies helps SecurePoint 360 personalize your
              experience when you visit the Site.
            </p>
            <p>
              Email: SecurePoint 360 may include Web Beacons in HTML-formatted
              email messages that SecurePoint 360 sends to you. Web Beacons in
              email messages helps SecurePoint 360 determine your interest in
              and the effectiveness of such emails.
            </p>
            <p>
              External use of Web Beacons: SecurePoint 360 may also use Web
              Beacons externally. For example, SecurePoint 360 may report
              aggregate information about visitors, such as demographic and
              usage information, to its affiliates and other third parties.
              SecurePoint 360 may also include other Web Beacons within the
              Site.
            </p>
          </div>
          <div id="your-opt-in-opt-out">
            <h2>Your opt in/opt out choices</h2>
            <p>
              You may “opt in” and/or “opt out” of certain uses of your Personal
              Information. For example, you may have the opportunity to choose
              whether you would like to receive email correspondence from us.
              Your Personal Information will not be shared with third-party
              service providers unless you give consent. You will have the
              opportunity to opt out of Company marketing emails by clicking the
              “opt out” or “unsubscribe” link in the email you receive. You can
              also request this via email{' '}
              <a href="mailto:privacy@securepoint360.com">
                privacy@securepoint360.com
              </a>
              .
            </p>
            <p>
              Please take note that if you opt out of receiving promotional
              correspondence from us, we may still contact you in connection
              with your relationship, activities, transactions, and
              communications with us.
            </p>
          </div>
          <div id="permitted-use">
            <h2>Permitted Use of Personal Information</h2>
            <p>
              SecurePoint 360 uses your Personal Information to provide you with
              products and services, such as to fulfill your requests for
              products or to help us personalize our offerings to you. We also
              use your Personal Information to support our business functions,
              such as fraud prevention, marketing, and legal functions. To do
              this, we combine personal and non-personal information, collected
              online and offline, including information from third-party
              sources.
            </p>
            <ul>
              <li>
                Fulfill Requests: To fulfill your requests for products and
                services and communicate with you about those requests.
              </li>
              <li>
                Understand Customer Behavior: To better understand customer
                behavior so that we may improve our marketing and advertising
                efforts and improve the distribution of our products and
                services.
              </li>
              <li>
                Personalize Offerings: To help us personalize our service
                offerings, websites, mobile services, and advertising.
              </li>
              <li>
                Protection: To protect the security and integrity of our
                websites, mobile services, and our business.
              </li>
              <li>
                Legal: To comply with legal and/or regulatory requirements.
              </li>
              <li>
                Responding to Customer: To respond to reviews, comments, or
                other feedback you provide us.
              </li>
              <li>
                Employment Applications: In connection with a job application or
                inquiry, you may provide us with data about yourself, including
                your educational background or resume and other information,
                including your ethnicity where required or permitted by law. We
                may use this information throughout SecurePoint 360, its
                subsidiaries and affiliates, and its joint ventures for the
                purpose of employment consideration.
              </li>
              <li>
                Promotional Messaging or Advertising: With your consent,
                SecurePoint 360 uses your contact information to recommend
                products and services that might be of interest to you, to send
                you marketing and advertising messages such as newsletters,
                announcements, or special offers, or to notify you about our
                upcoming events. If at any time, you would like to discontinue
                receiving any such email updates, you may unsubscribe by
                following the unsubscribe instructions included in each
                promotional email.
              </li>
            </ul>
          </div>
          <div id="use-disclosure-sharing">
            <h2>Use, disclosure, and sharing of Personal Information</h2>
            <h3>Service providers</h3>
            <p>
              We may use third-party partners to help us operate and maintain
              our Website and deliver our products and services. We may also
              share your information with our service providers and other third
              parties (“Affiliated Parties”) that provide products or services
              for or through this Website or for our business (such as website
              or Infrastructure hosting companies, communications providers,
              email providers, analytics companies, credit card processing
              companies and other similar service providers that use such
              information on our behalf).
            </p>
            <p>
              Third-party service providers are contractually restricted from
              using or disclosing the information, except as necessary to
              perform services on our behalf or to comply with legal
              requirements.
            </p>
            <h3>Compelled disclosures</h3>
            <p>
              SecurePoint 360 may be required to disclose collected information
              in order to (i) respond to investigations, court orders, or legal
              processes, (ii) to investigate, prevent, or take action regarding
              illegal activities, suspected fraud, potential threats to the
              physical safety of any person, (iii) violations of the Company’s
              terms of service, or (iv) as otherwise required by law.
            </p>
            <h3>Your ability to access, limit use and disclosure</h3>
            <p>
              You may request access to your personal data to update, correct,
              or delete, or to limit the use or disclosure of, your personal
              data.
            </p>
            <p>
              Individuals wishing to view, update, delete, or supplement their
              personal data may do so by contacting the business that provided
              SecurePoint 360 your personal data directly to make your requests,
              or alternatively, you can submit your request to{' '}
              <a href="mailto:privacy@securepoint360.com">
                privacy@securepoint360.com
              </a>
              .
            </p>
            <h3>Disclosure of Personal Information</h3>
            <p>
              SecurePoint 360 does not sell or otherwise disclose the Personal
              Information it holds to third parties, except for the following
              exceptional circumstances:
            </p>
            <ul>
              <li>
                <strong>Third Parties:</strong> SecurePoint 360 will not rent or
                sell your Personal Information to others but may disclose
                Personal Information with third-party vendors and service
                providers that work with SecurePoint 360. We will only share
                Personal Information with these vendors and service providers to
                help us provide a product or service to you at your request and
                in accordance with our respective agreement. We will ensure
                appropriate contractual clauses are in place to ensure
                compliance with data protection legislation.
              </li>
              <li>
                <strong>Business Purposes:</strong> In a prospective business
                transaction, SecurePoint 360 may disclose Personal Information
                where SecurePoint 360 has entered into an agreement that
                restricts the use and disclosure of that data solely for
                purposes related to the transaction, protects the data by
                security safeguards appropriate to the sensitivity of the
                information, and if the transaction does not proceed, the data
                is returned to SecurePoint 360 or destroyed within a reasonable
                time. With respect to employee data, SecurePoint 360 may
                disclose Personal Information if it is necessary to establish,
                manage, or terminate an employment relationship, as allowed by
                law.
              </li>
              <li>
                <strong>Legal and Safety Reasons:</strong> SecurePoint 360 may
                be required to disclose Personal Information to law enforcement
                agencies, government agencies, or legal entities. We may
                disclose information by law, litigation, or as a matter of
                national security to comply with a valid legal process including
                subpoenas, court orders, or search warrants, and as otherwise
                authorized by law. We may also need to disclose Personal
                Information in the event of an emergency that threatens an
                individual’s life, health, or security. If the data requested is
                held on behalf of a customer, SecurePoint 360 will consult the
                customer unless it is prohibited to do so by law. SecurePoint
                360 may be required to disclose information without your consent
                or knowledge if: (i) it is reasonable to expect that disclosure
                with your knowledge or consent would compromise an investigation
                of a breach of an agreement or a contravention of the law; (ii)
                it is reasonable for the purposes of preventing, detecting or
                suppressing fraud and it is reasonable to expect that the
                disclosure with your knowledge or consent would compromise the
                ability to prevent, detect or suppress the fraud; (iii) it is
                necessary to identify an individual who is injured, ill or
                deceased to a government institution or the individual’s next of
                kin or authorized representative and, if the individual is
                alive, with notification to the individual.
              </li>
              <li>
                <strong>
                  Via Links to Third-Party Websites, Services, and Applications:
                </strong>{' '}
                Using our website or services may link to third-party web
                websites, services, and applications. SecurePoint 360 is not
                responsible for any Personal Information collected through these
                means. Information collected is governed through the third
                party’s website’s privacy policy. Any interactions you have with
                these web websites, services, or applications are beyond the
                control of SecurePoint 360.
              </li>
            </ul>
          </div>
          <div id="security">
            <h2>Security</h2>
            <p>
              We take reasonable and appropriate precautions, including
              administrative, technical, personnel, and physical measures, to
              safeguard Personal Data against loss, misuse, theft, and
              unauthorized access, disclosure, alteration, and destruction. We
              also use Secure Sockets Layer (SSL) encryption when transmitting
              sensitive information. Please keep in mind that due to the
              inherent nature of the Internet, there is no way to make the
              transmission of electronic data entirely safe from intrusion.
            </p>
          </div>
          <div id="data-retention-and-storage">
            <h2>Data Retention and Storage</h2>
            <p>
              All Personal Information is retained only for as long as it is
              necessary for the purposes for which it was collected or
              transferred. SecurePoint 360 retains your information for business
              purposes, for as long as your account is active, and/or as long as
              is reasonably necessary to provide you with our products and
              services. SecurePoint 360 will also retain your information as
              reasonably necessary to comply with our legal obligations, resolve
              disputes, and enforce our agreements. We may also retain cached or
              archived copies of your information for a reasonable period of
              time. At any point in time, you can withdraw consent and we will
              immediately stop processing your data.
            </p>
          </div>
          <div id="data-retention-and-storage">
            <h2>Company Response to a Data Request and/or Security Breach</h2>
            <p>
              In regard to the aforementioned rights to voice questions, make
              requests regarding your data privacy, or withdraw consent, we will
              respond to your request within 30 days. In some cases, however, we
              may limit or deny your request if: the law permits or requires us
              to do so, if it infringes on the privacy of other individuals or
              internal procedures, if we find the request to be unfounded or
              excessive, or if we are unable to verify your identity.
            </p>
            <p>
              If the volume or complexity of the request requires internal
              processing at SecurePoint 360 beyond 30 days, SecurePoint 360 will
              inform the requester within 30 days of the reasons for an
              extension and may charge a reasonable fee to cover administrative
              costs.
            </p>
            <p>
              Security of all information is of the utmost importance for
              SecurePoint 360. SecurePoint 360 uses technical and physical
              safeguards to protect the security of your Personal Information
              from unauthorized disclosure. We use encryption technology to keep
              all information secure. We also make all attempts to ensure that
              only necessary people and third parties have access to Personal
              Information. Nevertheless, such security measures cannot prevent
              all loss, misuse, or alteration of Personal Information and,
              unless otherwise agreed in a written agreement between SecurePoint
              360 and the applicable party, we are not responsible for any
              damages or liabilities relating to any such incidents to the
              fullest extent permitted by law. In the case of a data breach, we
              will notify you without undue delay of any loss, misuse, or
              alteration of Personal Information that may affect you. We will
              notify relevant regulatory bodies within 72 hours of a breach.
            </p>
          </div>
          <div id="third-parties">
            <h2>
              Third Parties who may receive personal data (Onward Transfer)
            </h2>
            <p>
              As articulated previously in this policy, SecurePoint 360 may
              employ and contract with third-party service providers and other
              entities to assist in providing our services to customers by
              performing certain tasks on our behalf. These third-party
              providers may offer customer support, data storage services (data
              centers), or technical operations. SecurePoint 360 maintains
              contracts with these third parties restricting their access, use,
              and disclosure of personal data. These third parties may access,
              process, or store personal data in the course of providing their
              services. Unless we tell you differently, our Agents do not have
              any right to use Personal Information or other information we
              share with them beyond what is necessary to assist us. You hereby
              consent to our sharing of Personal Information with our Agents.
            </p>
          </div>
          <div id="ability-to-choose">
            <h2>Your Ability to Choose How Your Data Is To Be Used</h2>
            <p>
              Individuals may “opt in” and/or “opt out” of certain uses of your
              Personal Information. For details on how you can exercise your
              choices please refer to the “Your opt/in opt/out choices” section
              of this privacy policy.
            </p>
            <h3>Fair Information Practices</h3>
            <p>
              The Fair Information Practices Principles form the backbone of
              privacy law in the United States and the concepts they include
              have played a significant role in the development of data
              protection laws around the globe. Understanding the Fair
              Information Practice Principles and how they should be implemented
              is critical to comply with the various privacy laws that protect
              personal information.
            </p>
            <p>
              In order to be in line with Fair Information Practices we will
              take the following responsive action, should a data breach occur:
            </p>
            <ul>
              <li>We will notify the users via email Within 7 business days</li>
              <li>
                We also agree to the individual redress principle, which
                requires that individuals have a right to pursue legally
                enforceable rights against data collectors and processors who
                fail to adhere to the law. This principle requires not only that
                individuals have enforceable rights against data users, but also
                that individuals have recourse to courts or a government agency
                to investigate and/or prosecute non-compliance by data
                processors.
              </li>
            </ul>
          </div>
          <div id="can-spam-act">
            <h2>CAN-SPAM Act</h2>
            <p>
              The CAN-SPAM Act is a law that sets the rules for commercial
              email, establishes requirements for commercial messages, gives
              recipients the right to have emails stopped from being sent to
              them, and spells out tough penalties for violations.
            </p>
            <p>To be in accordance with CAN-SPAM we agree to the following:</p>
            <p>
              If at any time you would like to unsubscribe from receiving future
              emails, you can email us at{' '}
              <a href="mailto:privacy@securepoint360.com">
                privacy@securepoint360.com
              </a>
              and we will promptly remove you from ALL correspondence.
            </p>
          </div>
          <div id="contact-us">
            <h2>Contact us</h2>
            <p>
              If you have any questions or comments about this Privacy Policy,
              or if you would like to review, delete, or update information we
              have about you or your preferences, requests should be submitted
              via{' '}
              <a href="mailto:privacy@securepoint360.com">
                privacy@securepoint360.com
              </a>{' '}
              or to:
            </p>
            <p>
              <strong>SecurePoint 360, LLC.</strong>
              <br />
              180 Main Street, Unit 373
              <br />
              Butler NJ 07405
            </p>
          </div>
          <div id="terms-of-use">
            <h2>Terms of use</h2>
            <p>
              This Privacy Policy is governed by the Terms of Use, which
              includes all disclaimers of warranties and limitation of
              liabilities. All capitalized terms not defined in this Privacy
              Policy will have the meaning set forth in the Terms of Use.
            </p>
            <p>
              To review other applicable terms and conditions that apply to this
              Privacy Policy, including, without limitation, intellectual
              property rights, representations and warranties, disclaimer of
              warranties, limitation of liability, and resolving disputes,
              please review the Terms of Use.
            </p>
          </div>
          <div id="privacy-statement">
            <h2>Updates to our privacy statement</h2>
            <p>
              We may need to change, modify, and/or update this Privacy Policy
              from time to time and we reserve the right to do so without prior
              notice and at any time. If we do make changes in the way personal
              information is used or managed, any updates will be posted here,
              so you should also revisit this Privacy Policy periodically. Your
              continued use of the Site and any Services following the posting
              of any such changes shall automatically be deemed your acceptance
              of all changes.
            </p>
          </div>
          <div id="us-regional-privacy-notice">
            <h1>US Regional Privacy Notice</h1>
            <p>Last updated: April 17, 2024</p>
            <h2>Introduction</h2>
            <p>
              This Notice explains how we collect, use, and disclose your
              Personal Information. It also describes how to exercise your
              rights under the California Consumer Privacy Act, the Colorado
              Privacy Act, the Connecticut Act Concerning Personal Data Privacy
              and Online Monitoring, the Massachusetts Information Privacy Act,
              the Nevada Privacy of Information Collected on the Internet from
              Consumers Act, the New York Privacy Act, the Utah Consumer Privacy
              Act, and the Virginia Consumer Data Protection Act. We call these
              laws collectively the “U.S. Privacy Laws.”
            </p>
            <p>
              When we say “Personal Information” in this Notice, we mean
              information that identifies, relates to, describes, is reasonably
              capable of being associated with, or could reasonably be linked
              with you, directly or indirectly. Personal Information does not
              include information that cannot be reasonably linked to you.
            </p>
            <h3>How we collect, use, and disclose Personal Information</h3>
            <p>
              To provide the products or features offered by SecurePoint 360 we
              process information about you, including Personal Information,
              whether or not you have an account or are logged in. To learn
              about the types of information we collect and how we use it, you
              can review our Privacy Policy.
            </p>
            <p>
              Subject to the limitations we describe in our Privacy Policy, we
              may disclose your Personal Information for business purposes, with
              strict restrictions on how our partners can use and disclose the
              data we provide. We may also disclose it at your direction or in
              other ways that are in accordance with the U.S. Privacy Laws. We
              don’t “share” your Personal Information, as defined in the
              California Consumer Privacy Act (“CCPA”).
            </p>
            <p>
              We collect information that identifies, relates to, describes,
              references, is capable of being associated with, or could
              reasonably be linked, directly or indirectly, with a particular
              consumer or device (“personal information”). In particular, we
              have collected the following categories of personal information
              from consumers within the last twelve (12) months:
            </p>
            <table>
              <tbody>
                <tr>
                  <th>Category</th>
                  <th>Examples</th>
                  <th>Collected</th>
                </tr>
                <tr>
                  <td>
                    <p>A. Identifiers.</p>
                  </td>
                  <td>
                    <p>
                      A real name, alias, postal address, unique personal
                      identifier, online identifier, Internet Protocol address,
                      email address, account name, Social Security number,
                      driver's license number, passport number, or other similar
                      identifiers.
                    </p>
                  </td>
                  <td>
                    <p>Yes</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>B. Personal information categories</p>
                  </td>
                  <td>
                    <p>
                      A name, signature, Social Security number, physical
                      characteristics or description, address, telephone number,
                      passport number, driver's license or state identification
                      card number, insurance policy number, education,
                      employment, employment history, bank account number,
                      credit card number, debit card number, or any other
                      financial information, medical information, or health
                      insurance information. Some personal information included
                      in this category may overlap with other categories.
                    </p>
                  </td>
                  <td>
                    <p>No</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      C. Protected classification characteristics under US
                      Regional Laws.
                    </p>
                  </td>
                  <td>
                    <p>
                      Age (40 years or older), race, color, ancestry, national
                      origin, citizenship, religion or creed, marital status,
                      medical condition, physical or mental disability, sex
                      (including gender, gender identity, gender expression,
                      pregnancy or childbirth, and related medical conditions),
                      sexual orientation, veteran or military status, genetic
                      information (including familial genetic information).
                    </p>
                  </td>
                  <td>
                    <p>No</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>D. Commercial information.</p>
                  </td>
                  <td>
                    <p>
                      Records of personal property, products or services
                      purchased, obtained, or considered, or other purchasing or
                      consuming histories or tendencies.
                    </p>
                  </td>
                  <td>
                    <p>Yes</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>E. Biometric information.</p>
                  </td>
                  <td>
                    <p>
                      Genetic, physiological, behavioral, and biological
                      characteristics or activity patterns used to extract a
                      template or other identifier or identifying information,
                      such as fingerprints, faceprints, voiceprints, iris or
                      retina scans, keystroke, gait, or other physical patterns,
                      and sleep, health, or exercise data.
                    </p>
                  </td>
                  <td>
                    <p>No</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>F. Internet or other similar network activity.</p>
                  </td>
                  <td>
                    <p>
                      Browsing history, search history, and information on a
                      consumer's interaction with a website, application, or
                      advertisement.
                    </p>
                  </td>
                  <td>
                    <p>Yes</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>G. Geolocation data.</p>
                  </td>
                  <td>
                    <p>Physical location or movements.</p>
                  </td>
                  <td>
                    <p>No</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>H. Sensory data.</p>
                  </td>
                  <td>
                    <p>
                      Audio, electronic, visual, thermal, olfactory, or similar
                      information.
                    </p>
                  </td>
                  <td>
                    <p>No</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>I. Professional or employment-related information.</p>
                  </td>
                  <td>
                    <p>
                      Current or past job history or performance evaluations.
                    </p>
                  </td>
                  <td>
                    <p>Yes</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      J. Non-public education information (per the Family
                      Educational Rights and Privacy Act (20 U.S.C. Section
                      1232g, 34 C.F.R. Part 99)).
                    </p>
                  </td>
                  <td>
                    <p>
                      Education records directly related to a student maintained
                      by an educational institution or party acting on its
                      behalf, such as grades, transcripts, class lists, student
                      schedules, student identification codes, student financial
                      information, or student disciplinary records.
                    </p>
                  </td>
                  <td>
                    <p>Yes</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>K. Inferences drawn from other personal information.</p>
                  </td>
                  <td>
                    <p>
                      Profile reflecting a person's preferences,
                      characteristics, psychological trends, predispositions,
                      behavior, attitudes, intelligence, abilities, and
                      aptitudes.
                    </p>
                  </td>
                  <td>
                    <p>Yes</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>L.&nbsp; Sensitive Personal Information</p>
                  </td>
                  <td>
                    <p>
                      Biometric information for purposes of identifying a
                      consumer; personal information collected and analyzed
                      concerning a consumer&rsquo;s health, and personal
                      information collected and analyzed concerning a
                      consumer&rsquo;s sex life or sexual orientation
                    </p>
                  </td>
                  <td>
                    <p>No</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              We will use and retain the collected personal information as
              needed to provide the Services or for:
            </p>
            <ul>
              <li>Category A - As long as the user has an account with us</li>
              <li>Category D- As long as the user has an account with us</li>
              <li>Category I - As long as the user has an account with us</li>
              <li>Category J - As long as the user has an account with us</li>
              <li>Category K - As long as the user has an account with us</li>
            </ul>
            <p>
              We may also collect other personal information outside of these
              categories through instances where you interact with us in person,
              online, or by phone or mail in the context of:
            </p>
            <ul>
              <li>Receiving help through our customer support channels;</li>
              <li>Participation in customer surveys or contests; and</li>
              <li>
                Facilitation in the delivery of our Services and to respond to
                your inquiries.
              </li>
            </ul>
          </div>
          <div id="consumer-rights">
            <h2>Consumer's Rights</h2>
            <p>
              Depending on where you live and subject to certain exceptions, you
              may have some or all of the following rights:
            </p>
            <ul>
              <li>
                <strong>Right to Correct</strong>: You have the right to request
                the correction of any inaccurate personal information that we
                maintain about you, considering the nature of the personal
                information and the purposes of the processing of the personal
                information. We will use commercially reasonable efforts to
                correct the inaccurate personal information as you may direct.
              </li>
              <li>
                <strong>Right to Know</strong>: The right to request that we
                disclose to you the Personal Information we collect, use, or
                disclose, and information about our data practices.
              </li>
              <li>
                <strong>Right to Request Deletion</strong>: The right to request
                that we delete your Personal Information that we have collected
                from or about you.
              </li>
              <li>
                <strong>Right to Opt Out</strong>: The right to opt out of the
                processing of your Personal Information that has been obtained
                from or about you.
              </li>
              <li>
                <strong>Right to Non-Discrimination</strong>: The right not to
                receive discriminatory treatment for exercising your privacy
                rights.
              </li>
              <li>
                <strong>Do Not Track</strong>: SecurePoint 360 does not track
                its customers over time and across third-party websites to
                provide targeted advertising and therefore does not respond to
                Do Not Track (DNT) signals. Third parties that have content
                embedded on SecurePoint 360 websites such as a social feature
                may set cookies on a user’s browser and/or obtain information
                about the fact that a web browser visited a specific Company
                website from a certain IP address. Third parties cannot collect
                any other personal information from the Company’s websites
                unless you provide it to them directly.
              </li>
            </ul>

            <p>
              To submit a request to exercise your rights, and as applicable, to
              appeal a consumer rights action, please visit our{' '}
              <a href="https://securepoint360.com/opt-out-preferences/">
                Opt-Out Preferences form
              </a>{' '}
              or email us at{' '}
              <a href="mailto:privacy@securepoint360.com">
                privacy@securepoint360.com
              </a>
            </p>
            <p>
              If you choose to submit a request, you must provide us with enough
              information to identify you (e.g., your first and last name and
              email address) and enough specificity on the requested data. We
              will only use the information we receive to respond to your
              request. We will not be able to disclose information if we cannot
              verify that the person making the Consumer Request is the person
              about whom we collected information, or someone authorized to act
              on such person's behalf. We will verify your request by comparing
              the information you provide with the information we have on you
              and, if your request is submitted by an authorized agent, we will
              require you to provide signed, written permission for such agent
              to act on your behalf.
            </p>
          </div>
          <div id="transfer-personal-data">
            <h2>Transfers of Personal Data</h2>
            <p>
              The Services are hosted and operated in the United States ("U.S.")
              through its service providers, and if you do not reside in the
              U.S., laws in the U.S. may differ from the laws where you reside.
              By using the Services, you acknowledge that any Personal Data
              about you, regardless of whether provided by you or obtained from
              a third party, is being provided in the U.S. and will be hosted on
              U.S. servers, and you authorize SecurePoint 360 to transfer, store
              and process your information to and in the U.S., and possibly
              other countries.
            </p>
          </div>
          <div id="security">
            <h2>Security</h2>
            <p>
              To help protect the privacy of data and personally identifiable
              information you transmit through the use of this site and any
              other related services, we maintain physical, technical, and
              administrative safeguards. We update and test our security
              technology on an ongoing basis. We restrict access to your
              personal data to those employees who need to know that information
              to provide benefits or services to you. In addition, we train our
              employees about the importance of confidentiality and maintaining
              the privacy and security of your information. We commit to taking
              appropriate disciplinary measures to enforce our employees'
              privacy responsibilities.
            </p>
            <p>
              A copy of our written Information Security Plan is available upon
              request - contact us at{' '}
              <a href="mailto:privacy@securepoint360.com">
                privacy@securepoint360.com
              </a>{' '}
              to request a copy.
            </p>
          </div>
        </div>
        {this.renderNotification()}
      </>
    );
  }
}
// const style = {
//     margin: 15,
// };
export default PrivacyPolicy;
